import InvoiceDetailPage from '@/pages/Invoice/InvoiceDetail/InvoiceDetailPage';

const BudgetInvoiceDetail = () => {
  return <InvoiceDetailPage />;
};

export default BudgetInvoiceDetail;
